import { render } from "./TaskTable.vue?vue&type=template&id=bfd0da38"
import script from "./TaskTable.vue?vue&type=script&lang=js"
export * from "./TaskTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__